import { InView, IntersectionOptions } from 'react-intersection-observer'

const defaultOptions = {
  triggerOnce: true,
}

export interface LazyLoadProps {
  children: React.ReactNode
  options?: IntersectionOptions
}

function LazyLoad({
  children,
  options = defaultOptions,
}: LazyLoadProps): React.ReactElement {
  return (
    <InView {...options}>
      {({ ref, inView }) => {
        return <div ref={ref}>{inView && children}</div>
      }}
    </InView>
  )
}

export default LazyLoad
